import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { _Col2ArticleRichTextContentBlocks, _Col2ArticleRichTextContentEntityMap, } from "@discovery/sonic-api-ng-optics";
import { view } from "./view";
export const getRichTextContentBlocks = (data) => Fold.toArray(_Col2ArticleRichTextContentBlocks, data).map((x) => ({
    data: pipe(x.data, Option.getOrElse(() => ({}))),
    depth: pipe(x.depth, Option.getOrElse(() => 0)),
    key: pipe(x.key, Option.getOrElse(() => Math.random().toString())),
    text: x.text,
    type: x.type,
    entityRanges: pipe(x.entityRanges, Option.getOrElse(() => [])),
    inlineStyleRanges: pipe(x.inlineStyleRanges, Option.getOrElse(() => [])),
}));
const getProps = (data) => {
    const blockL = getRichTextContentBlocks(data);
    const entityMapM = Fold.preview(_Col2ArticleRichTextContentEntityMap, data);
    const bodyM = Option.some({
        blocks: blockL,
        entityMap: pipe(entityMapM, Option.getOrElse(() => ({}))),
    });
    return { bodyM };
};
const PrivacyPolicy = ({ bodyM }) => view(bodyM);
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PrivacyPolicy);

